export default {

    // 当前账户
    account: JSON.parse(localStorage.getItem('account')),

    // 全局：消息
    noticeData: [],

    // 当前：省/市/区县/地址 编码
    addressCode: null,
}



// WEBPACK FOOTER //
// ./src/store/state.js